var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-content"},[(_vm.show100DaysBanner)?_c('img',{attrs:{"src":"/images/im-on-it/on-it-header-logo.svg","aria-label":"על זה ביחד"}}):_vm._e(),_vm._v(" "),_c('story-menu-header')],1)}
var staticRenderFns = []

export { render, staticRenderFns }